<style scoped lang="css">
  #register {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
<template>
  <v-app key="register">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md8 lg6 xl6 style="text-align: center">
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img width="400px" src="../../../public/img/yoclass/laptop_email.jpg"/>
                  <div class="flex my-4" style="font-size: 20px">
                    <div style="font-weight: bold">Bạn đã gửi thông tin thành công.</div>
                    <div style="font-weight: bold">Hội đồng chuyên môn Yoclass sẽ liên hệ trong vòng 24h làm việc để duyệt quyền giảng viên Yoclass cho bạn.</div>
                    <div>Hãy để ý điện thoại để không bị cuộc gọi nhỡ nhé.</div>
                    <a class="primaryColor" href="/#/login">Về trang đăng nhập</a>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>


<script>
  import {router} from '@/router';


  export default {
    components: {
    },
    data() {
      return {
        username: '',
        password: '',
        show: "phone",
        submitted: false,
        register: {},
        profile: {},
        roles: [
          {
            text: this.$t('lang.user.teacher'),
            value: 1
          },
          {
            text: this.$t('lang.user.pupil'),
            value: 2
          },
        ]
      }
    },
    created() {
      if (this.$store.state.auth.loggedIn) {
        this.$router.push('/HomePage');
      }
      this.register = {};
      let v = this;
      //
      // init facebook
      //
      window.fbAsyncInit = function () {
        FB.init({
          appId: '998333920543921',
          cookie: true,
          xfbml: true,
          version: 'v5.0'
        });

        //FB.AppEvents.logPageView();

      };

      (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));

    },
    methods: {
      verify() {
        this.$validator.validate().then(valid => {
          //console.log(valid);
          if (!valid) {
            message.error(this.$t("lang.common.validate_fail"));
            return;
          }
          this.register.accountType = "phone";
          axios.post(process.env.VUE_APP_API_URL + "/register/verify", this.register).then(
                  data => {
                    if (data.success) {
                      this.show = "detail";
                      this.register.birthday = null;
                    } else {
                      message.error(this.$t(data.description));
                    }
                  },
                  error => {
                    //console.log(error);
                  }
          );
        });
      },

      registerPhone: function () {
        this.register.accountType = "phone";
        this.$validator.validate().then(valid => {
          //console.log(valid);
          if (!valid) {
            message.error(this.$t("lang.common.validate_fail"));
            return;
          }
          this.register.accountType = "phone";
          this.register.id = this.register.phone;
          this.register.userName = this.register.phone;
          axios.post(process.env.VUE_APP_API_URL + "/register/sendVerify", this.register).then(
                  data => {
                    if (data.success) {
                      this.register.verify="";
                      this.show = "validate";
                    } else {
                      message.error(this.$t(data.description));
                    }
                  },
                  error => {
                    //console.log(error);
                  }
          );
        });
      },

      resend: function () {
        axios.post(process.env.VUE_APP_API_URL + "/register/sendVerify", this.register).then(
                data => {
                  if (data.success) {
                    message.success("Gửi lại thành công");
                  } else {
                    message.error(this.$t(data.description));
                  }
                },
                error => {
                  //console.log(error);
                }
        );
      },

      registerProfile: function () {
        this.$validator.validate().then(valid => {
          if (!valid) {
            message.error(this.$t("lang.common.validate_fail"));
            return;
          }
          axios.post(process.env.VUE_APP_API_URL + "/register/sendProfile", this.register).then(
                  data => {
                    if (data.success) {
                      message.success(this.$t(data.description));
                      if (this.register.role == 1) {
                        //
                        // is teacher -> nead to update profile
                        //
                        this.register.userId = data.id;
                        this.show = "profile";
                        this.profile.userId = data.id;
                        this.profile.teacherName = this.register.fullName;
                        this.profile.email = this.register.email;
                      } else {
                        this.show = "phone";
                        this.register = {};
                        this.profile = {};
                        router.push("/login");
                      }
                    } else {
                      message.error(this.$t(data.description));
                    }
                  },
                  error => {
                    //console.log(error);
                  }
          );
        });

      },

      registerTeacherProfile: function () {
        this.$validator.validate().then(valid => {
          if (!valid) {
            message.error(this.$t("lang.common.validate_fail"));
            return;
          }
          axios.post(process.env.VUE_APP_API_URL + "/register/sendTeacherProfile", this.profile).then(
                  data => {
                    if (data.success) {
                      message.success(this.$t(data.description));
                      if (this.register.role == 1) {
                        //
                        // is teacher -> nead to update profile
                        //
                        this.show = "phone";
                        this.register = {};
                        this.profile = {};
                      } else {
                        this.show = "phone";
                        this.register = {};
                        this.profile = {};
                      }
                      router.push("/login");
                    } else {
                      message.error(this.$t(data.description));
                    }
                  },
                  error => {
                    //console.log(error);
                  }
          );
        });
      },

      cancel: function () {
        this.show = "phone";
      },

      getFacebookInfo: function (author, vue) {
        FB.api('/me', 'get', {
          access_token: author.authResponse.access_token,
          fields: 'id,name,gender,address,birthday,email,languages'
        }, function (userInfo) {
          userInfo.avatar = "https://graph.facebook.com/" + userInfo.id + "/picture?type=normal";
          userInfo.accountType = "facebook";
          userInfo.fullName = userInfo.name;
          userInfo.userName = userInfo.id;
          userInfo.birthday = null;
          vue.register = userInfo;
          vue.show = "detail";

        });

      },

      facebookRegister: function () {
        let v = this;
        FB.getLoginStatus(function (r) {
          if (r.status === 'connected') {
            v.getFacebookInfo(r, v);
          } else {
            FB.login(function (author) {
              v.getFacebookInfo(author, v);
            }, {scope: 'email'}); // which data to access from user profile
          }
        });
      },

      googleRegister: function () {
        var auth2;
        var v = this;
        gapi.load('auth2', function () {
          auth2 = gapi.auth2.init({
            client_id: '98948171933-iutm4oq2i464cvhl5s24ecc6luvmvbbi.apps.googleusercontent.com',
            fetch_basic_profile: true,
            scope: 'profile'
          });

          // Sign the user in, and then retrieve their ID.
          auth2.signIn().then(function () {
            let userInfo = auth2.currentUser.get();
            //console.log(userInfo);
            let profile = userInfo.getBasicProfile();
            //console.log(profile);
            let user = {
              id: profile.getId(),
              userName: profile.getId(),
              fullName: profile.getName(),
              avatar: profile.getImageUrl(),
              email: profile.getEmail(),
              birthday: null,
              accountType: "google"
            };
            v.register = user;
            v.show = "detail";
          });
        });
      },

      toLandingPage: function () {
        this.$router.push("/LandingPage");
      }
    }
  };
</script>
<style>
</style>

